// newchat IM 接口：全部走 requestGo（自研 Go 后端）。路径与旧 api/custom.js 一致，仅换实例。
import request from '@/utils/requestGo'
import axios from 'axios'

// 文件上传走旧业务后端（与 requestCustom 同源），不经 Go。用独立 axios 让浏览器自动设 multipart 边界。
const BUSINESS_BASE = 'https://back.zhwapp.com'

// 上传图片/视频/语音，返回 { code, msg, data:{ filePath } }
export function ncUpload(file) {
    const fd = new FormData()
    fd.append('file', file)
    let token = window.localStorage.getItem('customToken')
    if (token && token !== 'undefined') {
        try {
            token = JSON.parse(token)
        } catch (e) {
            /* 已是裸字符串 */
        }
    } else {
        token = ''
    }
    return axios
        .post(`${BUSINESS_BASE}/upload/upHx`, fd, {
            headers: { Token: token, Authorization: token }
        })
        .then((r) => r.data)
}

// 取 IM 凭据 + hxusername（兜底建号）
export function ncGetUserToken() {
    return request({ url: '/im/msg/getUserToken', method: 'get' })
}

// 会话列表（分页 {rows,total}）
export function ncSessionList(params) {
    return request({ url: '/sessionList/h5/list', method: 'get', params })
}

// 进会话取最新 N 条
export function ncRecentList(params) {
    return request({ url: '/msg/history/recentList', method: 'get', params })
}

// 历史向上翻页（游标 lastId）
export function ncHistoryList(params) {
    return request({ url: '/msg/history/list', method: 'get', params })
}

// 发消息
export function ncSendMsg(data) {
    return request({ url: '/im/msg/sendMsg', method: 'post', data })
}

// 撤回
export function ncRevocation(data) {
    return request({ url: '/msg/history/revocation', method: 'post', data })
}

// 会话内搜索
export function ncSearchInSession(params) {
    return request({ url: '/msg/history/searchInSession', method: 'get', params })
}

// 官方客服列表
export function ncGetKefu() {
    return request({ url: '/im/msg/getKefu', method: 'get' })
}

// 群成员详情
export function ncGroupMembers(params) {
    return request({ url: '/group/info/membersDetail', method: 'get', params })
}

// 置顶/取消
export function ncTopOrCancel(data) {
    return request({ url: '/sessionList/topOrCancel', method: 'post', data })
}
